import React from "react";

const marketplaceLabels = {
  ebay: "eBay",
  facebook: "Facebook Marketplace",
  etsy: "Etsy",
  amazon: "Amazon",
};

const ProductCard = ({ product, showWishlist, isWished, onWishlistToggle }) => (
  <article className="storefront-product">
    <div className="storefront-product__media">
      <img src={product.imageUrl} alt={product.title} loading="lazy" />
      <span className="storefront-product__marketplace">
        {marketplaceLabels[product.marketplace] || product.marketplace}
      </span>
    </div>
    <div className="storefront-product__content">
      <h3 className="storefront-product__title">{product.title}</h3>
      <p className="storefront-product__price">
        {product.price} {product.currency}
      </p>
      <div className="storefront-product__actions">
        <a
          className="storefront-button storefront-button--primary"
          href={product.externalUrl}
          target="_blank"
          rel="noreferrer"
        >
          View listing
        </a>
        {showWishlist ? (
          <button
            type="button"
            className="storefront-button storefront-button--ghost"
            onClick={() => onWishlistToggle(product.id)}
          >
            {isWished ? "Saved" : "Save"}
          </button>
        ) : null}
      </div>
    </div>
  </article>
);

const StorefrontGrid = ({
  config,
  products,
  featuredProducts,
  isLoading,
  searchQuery,
  onSearchChange,
  marketplaces,
  activeMarketplace,
  onMarketplaceChange,
  wishlist,
  onWishlistToggle,
}) => {
  const showSearch = config.layout.showSearch;
  const showCategories = config.layout.showCategories && config.features.enableCategories;
  const showWishlist = config.features.enableWishlist;
  const showFeatured = config.features.enableFeatured && featuredProducts.length > 0;
  const hasProducts = products.length > 0;

  return (
    <section className={`storefront-grid storefront-grid--${config.layout.productGridStyle}`}>
      <div className="storefront-grid__toolbar">
        {showSearch ? (
          <div className="storefront-grid__search">
            <label htmlFor="storefront-search">Search listings</label>
            <input
              id="storefront-search"
              type="search"
              placeholder="Search by title"
              value={searchQuery}
              onChange={(event) => onSearchChange(event.target.value)}
            />
          </div>
        ) : null}

        {showCategories ? (
          <div className="storefront-grid__filter">
            <label htmlFor="storefront-marketplace">Marketplace</label>
            <select
              id="storefront-marketplace"
              value={activeMarketplace}
              onChange={(event) => onMarketplaceChange(event.target.value)}
            >
              <option value="all">All</option>
              {marketplaces.map((marketplace) => (
                <option key={marketplace} value={marketplace}>
                  {marketplaceLabels[marketplace] || marketplace}
                </option>
              ))}
            </select>
          </div>
        ) : null}
      </div>

      {showFeatured ? (
        <div className="storefront-grid__featured">
          <h2>Featured</h2>
          <div className="storefront-grid__featured-list">
            {featuredProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                showWishlist={showWishlist}
                isWished={wishlist.has(product.id)}
                onWishlistToggle={onWishlistToggle}
              />
            ))}
          </div>
        </div>
      ) : null}

      <div className="storefront-grid__list">
        {isLoading ? (
          <p className="storefront-grid__empty">Loading listings...</p>
        ) : hasProducts ? (
          products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              showWishlist={showWishlist}
              isWished={wishlist.has(product.id)}
              onWishlistToggle={onWishlistToggle}
            />
          ))
        ) : (
          <p className="storefront-grid__empty">No listings match this view.</p>
        )}
      </div>
    </section>
  );
};

export default StorefrontGrid;
